/**
 * @purpose: mengelola halaman daftar purchase vendor agar runtime pencarian, refresh, dan pagination berjalan stabil.
 * @called_by: views/app_vendor/vendor_view.html.
 * @deps: AngularJS app, _API_URL, modalService, urlServices, _VAR_GLOBAL, toaster.
 * @public: vendorViewCtrl.
 * @side_effects: memuat data vendor purchasing dari API dan menghapus vendor saat diminta user.
 */
app.controller('vendorViewCtrl', ['$scope', '_API_URL', 'modalService', 'urlServices', '_VAR_GLOBAL', 'toaster', function ($scope, _API_URL, modalService, urlServices, _VAR_GLOBAL, toaster) {
    $scope.filter = '';
    $scope.dataList = {
        totalItems: 0,
        summary: {},
        data: []
    };
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: _VAR_GLOBAL.limit,
        sort: null
    };

    function normalizeError(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }
        return String(err);
    }

    function getResponseData(result) {
        return result && result.data ? result.data : result;
    }

    $scope.edit = function (item) {
        var kode = item.KodeCustomer || item.kodecustomer;
        window.location = _API_URL + 'purchase-vendor-entry?screen=vendor&isedit=true&kodevendor=' + kode;
    };

    $scope.detail = function (item) {
        var kode = item.KodeCustomer || item.kodecustomer;
        window.location = _API_URL + 'purchase-vendor-entry?screen=vendor&isedit=true&isview=true&kodevendor=' + kode;
    };

    $scope.hapus = function (item) {
        var kode = item.KodeCustomer || item.kodecustomer;
        modalService.showModal({}, {
            headerText: 'Hapus Vendor',
            bodyText: 'Apakah Anda yakin ingin menghapus [' + kode + '] ?'
        }).then(function (result) {
            if (!result) {
                return;
            }

            urlServices.simpanData('api/purchase-vendor-delete', { KodeCustomer: kode }, function (err) {
                if (err) {
                    return toaster.pop('error', 'Vendor', normalizeError(err, 'Data gagal dihapus'));
                }

                toaster.pop('success', 'Vendor', 'Data berhasil dihapus');
                return $scope.viewData(1);
            });
        });
    };

    $scope.getData = function (pageSize, page, searchText) {
        var query = [
            'limit=' + encodeURIComponent(pageSize),
            'pg=' + encodeURIComponent(page)
        ];

        if (searchText) {
            query.push('term=' + encodeURIComponent(String(searchText).toLowerCase()));
        }

        return urlServices.ambilData('api/purchase-vendor?' + query.join('&'), {}, function (err, result) {
            var responseData;

            if (err) {
                $scope.dataList.totalItems = 0;
                $scope.dataList.data = [];
                return toaster.pop('error', 'Vendor', normalizeError(err, 'Gagal mengambil data vendor'));
            }

            responseData = getResponseData(result) || {};
            $scope.dataList.totalItems = responseData.total || 0;
            $scope.dataList.data = responseData.dt || [];
        });
    };

    $scope.viewData = function (page) {
        $scope.paginationOptions.pageNumber = page || 1;
        return $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter || '');
    };

    $scope.refreshData = function () {
        return $scope.viewData($scope.paginationOptions.pageNumber || 1);
    };

    $scope.excelReport = function () {
        toaster.pop('info', 'Vendor', 'Export Excel belum tersedia');
    };

    $scope.viewData(1);
}]);
